/**
 * Pipeline stage enum - matches backend current_stage values
 */
export enum PipelineStage {
  IDLE = 'IDLE',
  TEMPLATE_IN_PROGRESS = 'TEMPLATE_IN_PROGRESS',
  TEMPLATE_COMPLETE = 'TEMPLATE_COMPLETE',
  PRECHECK_IN_PROGRESS = 'PRECHECK_IN_PROGRESS',
  PRECHECK_COMPLETE = 'PRECHECK_COMPLETE',
  REPORT_IN_PROGRESS = 'REPORT_IN_PROGRESS',
  REPORT_COMPLETE = 'REPORT_COMPLETE',
  REPORT_FAILED = 'REPORT_FAILED',
}

/**
 * Get processing message translation keys based on current stage
 */
export const getProcessingMessageKeys = (stage: PipelineStage) => {
  const messageKeys = {
    [PipelineStage.TEMPLATE_IN_PROGRESS]: {
      titleKey: 'report-generation.processing.template-in-progress-title',
      messageKey: 'report-generation.processing.template-in-progress-message',
      showEmailNotification: false,
    },
    [PipelineStage.PRECHECK_IN_PROGRESS]: {
      titleKey: 'report-generation.processing.precheck-in-progress-title',
      messageKey: 'report-generation.processing.precheck-in-progress-message',
      showEmailNotification: false,
    },
    [PipelineStage.REPORT_IN_PROGRESS]: {
      titleKey: 'report-generation.processing.report-in-progress-title',
      messageKey: 'report-generation.processing.report-in-progress-message',
      showEmailNotification: true,
    },
  };

  return messageKeys[stage as keyof typeof messageKeys] || null;
};
